module.exports = __webpack_public_path__ + "img/iphone-deco-home.821fa2b8.png";